/**
 * Builds the auth headers for the user-management (Equipo) client.
 *
 * Deployed: the host holds a real Entra access token → send
 * `Authorization: Bearer <token>` so the request clears the API Gateway
 * authorizer. Local dev: the auth bypass returns the 'dev' sentinel (no real
 * token) → fall back to the X-Dev-* dev-stub headers core reads when ENV=dev.
 */
export function buildMembersAuthHeaders(
  token: string,
  authzUserId: string,
  workspaceId: number | null | undefined,
): HeadersInit {
  if (token && token !== 'dev') {
    return { Authorization: `Bearer ${token}` };
  }
  // An unseeded workspace sends no X-Dev-Workspace-IDs rather than inventing one:
  // core's dev stub reads that header straight into the Principal, so a placeholder
  // here becomes a claim of membership. The bootstrap calls (/me) don't need it —
  // they ask which workspaces the caller has.
  const headers: Record<string, string> = { 'X-Dev-User-ID': authzUserId };
  if (workspaceId != null) {
    headers['X-Dev-Workspace-IDs'] = String(workspaceId);
  }
  return headers;
}
